import { defineComponent as _defineComponent } from 'vue'
import { buttonEmits, buttonProps } from './button';


export default /*#__PURE__*/_defineComponent({
  __name: 'button',
  props: buttonProps,
  emits: buttonEmits,
  setup(__props, { emit: emits }) {

const props = __props




const handleClick = (event: Event): void => {
    if (props.disabled || props.loading) {
        event.stopPropagation();
        return;
    }

    emits('click');
};

return { __sfc: true,props, emits, handleClick }
}

})